export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const pct = (v, digits = 1) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);
export const CLASS_LABEL = {
  branded: 'Branded', competitor: 'Competitor', generic: 'Generic',
};
